import React, { useEffect } from 'react';
//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';


import fondo from '../../assets/img/landingPage/fondo.png';
import icon_free from '../../assets/img/landingPage/freeIcon.svg'
import icon_expo from '../../assets/img/landingPage/expoIcon.svg'
import icon_dyn from '../../assets/img/landingPage/dynamicIcon.svg'

import features_1 from '../../assets/img/landingPage/marketplace/Marketplace_01.png'
import features_2 from '../../assets/img/landingPage/marketplace/Marketplace_02.png'
import features_3 from '../../assets/img/landingPage/marketplace/Marketplace_03.png'
import features_4 from '../../assets/img/landingPage/marketplace/Marketplace-04.png'
import features_5 from '../../assets/img/landingPage/marketplace/Marketplace-05.png'
import features_6 from '../../assets/img/landingPage/marketplace/Marketplace-06.png'



import logo from '../../assets/img/logos/AVAP_Marketplace_white.svg'
import dividerbg from '../../assets/img/landingPage/hexagono-horizonte.png'




import gradientbottom from '../../assets/img/landingPage/gradientbottom.png'

import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'

const VersionControlProduct = () => {

    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);

        // clean favicon 
        return () => {
            document.head.removeChild(link);
        };
    }, []);


    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);

    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}>
               
                {/* Hero Section */}
                <section id="heroProduct" className="text-center pt-5">
                    <img
                        src={logo}
                        alt="Logo AVAP Marketplace"
                        className="img-fluid logo"
                    />
                    <h1 className="fl-title m-0">Designed for powerful API Products</h1>
                    <p className="fl-subtitle">
                        Discover, integrate, and accelerate your projects
                    </p>
                    <a className="glowBtn-dark" href="https://marketplace.avapcloud.com" target='_blank' aria-label="Button labeled 'Visit AVAP Marketplace' directing users to AVAP Marketplace."><span className="btnInner"> Visit AVAP Marketplace</span></a>
                </section>


                {/* Powerful API Platform */}
                <section className="container text-center pb-5">
                    <div className="row">
                        <div className="col">
                            {/* <img
                                src="https://placehold.co/1026x423"
                                alt="Platform Placeholder"
                                className="img-fluid mt-4 mb-5"
                            /> */}
                            <p className="fl-title mb-3">
                                A dynamic platform for API discovery and innovation
                            </p>
                            <p className="fl-text">
                                AVAP Marketplace is a platform that empowers organizations to showcase a diverse range of API Products, connectors, and advanced tools. It simplifies the certification, publishing, and monetization process, while delivering essential solutions to optimize projects and drive efficiency.
                            </p>
                        </div>
                    </div>

                </section>



                {/* Beyond a Proxy */}
                <section className="container py-5 gradient-d fl-br-20 mb-5">
                    <div className="row align-items-center">
                              <div className="col-md-6 pl-5">
                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">API Product Listing</h3>
                            <p className="fl-text">
                                Empowers tech companies to seamlessly publish and monetize API Products directly from AVAP Cloud, ensuring full control and flexibility.

                            </p>
                        </div>
                        <div className="col-md-6 text-center">
                            <img
                                src={features_1}
                                alt="Illustration of three API product cards"
                                className="img-fluid"
                            />
                        </div>
                  
                    </div>
                </section>

                <section className="container py-5 gradient-d fl-br-20 mt-5 mb-5">
                    <div className="row align-items-center">

                   


                        <div className="col-md-6 text-center">
                            <img
                                src={features_6}
                                alt="Illustration of AVAP Marketplace icon and pricing options including monthly and annual subscriptions."
                                className="img-fluid"
                            />
                        </div>

                             <div className="col-md-6 pr-5">
                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">Flexible Commercialization Models</h3>
                            <p className="fl-text">
                                Supports various economic models, such as monthly or annual subscription-based, with more complex models in future iterations.
                            </p>
                        </div>



                    </div>
                </section>

                {/* Comprehensive API Management */}
                <section className="container py-5 gradient-d fl-br-20 mt-5 mb-5">
                    <div className="row align-items-center">
                        <div className="col-md-6 pl-5">
                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">Developer Profiles</h3>
                            <p className="fl-text">
                                Incorporates developer company details from AVAP ID, including contact information and API project names, ensuring precise and professional representation on the platform.
                            </p>
                        </div>

                        <div className="col-md-6 text-center">
                            <img
                                src={features_2}
                                alt="Illustration of AVAP Marketplace interface displaying a developer profile with API product listings."
                                className="img-fluid"
                                style={{ maxWidth: '80%'}}
                            />
                        </div>
                    </div>
                </section>

                <section className="container py-5 gradient-d fl-br-20 mt-5 mb-5">
                    <div className="row align-items-center">

                        <div className="col-md-6 text-center">
                            <img
                                src={features_3}
                                alt="Illustration of AVAP Marketplace interface displaying a developer profile with the certification process."
                                className="img-fluid"
                                style={{ maxWidth: '80%'}}
                            />
                        </div>


                        <div className="col-md-6 pr-5">
                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">Comprehensive Certification Process</h3>
                            <p className="fl-text">
                                Offers a structured API Product certification workflow, from initial draft through review, approval, and public release, ensuring quality and compliance.
                            </p>
                        </div>

                    </div>
                </section>



                {/* Beyond a Proxy */}
                <section className="container py-5 gradient-d fl-br-20 mb-5">
                    <div className="row align-items-center">
                        <div className="col-md-6 pr-5">
                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">Wide Range of API Products</h3>
                            <p className="fl-text">
                                A comprehensive selection of API Products designed for industries such as finance, travel, and gaming. Discover and integrate solutions that address the specific demands of each sector seamlessly.

                            </p>
                        </div>
                        <div className="col-md-6 text-center">
                            <img
                                src={features_4}
                                alt="Graphic of an email invitation to join the AVAP Marketplace."
                                className="img-fluid"
                                style={{ maxWidth: '80%'}}
                            />
                        </div>

                    </div>
                </section>

                {/* Comprehensive API Management */}
                <section className="container py-5 gradient-d fl-br-20 mt-5 mb-5">
                    <div className="row align-items-center">


                        <div className="col-md-6 text-center">
                            <img
                                src={features_5}
                                alt="Illustration of AVAP Marketplace with API product listings."
                                className="img-fluid"
                            />

                        </div>

                        <div className="col-md-6 pl-5">
                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">API Products Visibility</h3>
                            <p className="fl-text">
                                A platform for managing API Products, enabling companies to list, manage certifications, and optimize sales, while ensuring maximum visibility and control over their offerings.
                            </p>
                        </div>
                    </div>
                </section>



                <section className="container fl-z-index-2 position-relative mb-8">
                    <div className="row">
                        <div className="col">
                            <div className="fl-title text-center mb-3">
                                Key Benefits
                            </div>
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                {/* <img src="https://placehold.co/50x50" alt="" /> */}
                                <p className="fl-subtitle-xs">
                                    Wide Selection of API Products and Tools
                                </p>
                                <p className="fl-text">
                                    Discover and integrate a diverse range of high-quality APIs, accelerating development and saving time. <br />
                                    &nbsp;
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                {/* <img src="https://placehold.co/50x50" alt="" /> */}
                                <p className="fl-subtitle-xs">
                                    Easy Certification and Monetization
                                </p>
                                <p className="fl-text">
                                    A streamlined certification process and flexible commercialization models allow developers to publish and monetize API products with ease.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                {/* <img src="https://placehold.co/50x50" alt="" /> */}
                                <p className="fl-subtitle-xs">
                                Secure Access and Role Management
                                </p>
                                <p className="fl-text">
                                AVAP Marketplace ensures robust security with advanced role management controls, giving you full control over access permissions. 
                                </p>
                            </div>
                        </div>
                    </div>
                </section>


                {/* Getting Started */}
                <div className="bottomWrapper position-relative d-flex justify-content-center">
                    <img src={gradientbottom} alt="" className="gradient gradientBottom" />
                </div>
            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default VersionControlProduct;
